import React from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
const live_black_gif = require('static/live-black.gif')

interface IProps {
  tag: string
  wrapClassName?: string
}

const LiveTag: React.FC<IProps> = ({ tag = '', wrapClassName = '' }) => {
  if (!tag) {
    return null
  }
  return (
    <div className={`live-tag ${wrapClassName}`}>
      {tag}
      <style jsx>
        {`
          .live-tag {
            display: inline-block;
            position: absolute;
            height: 24px;
            z-index: 1;
            top: 8px;
            right: 8px;
            padding: 4px 8px;
            border-radius: 2px;
            background-color: rgba(31, 33, 41, 0.6);
            font-family: PingFangSC;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
          }
        `}
      </style>
    </div>
  )
}

export default LiveTag
